module.exports = __webpack_public_path__ + "static/media/logo_mbsb.5f258c64.png";